import { EmptyState } from '@/features/shop/components/EmptyState'
import { getCMSWrapperProps } from '@/features/cms/components/CMS/utils/getCMSWrapperProps'
import { type PlaceholderData } from '@/features/cms/components/CMS/types'
import { objectStorageUrl } from '@/features/shared/utils/objectStorageUrl'
import styled from 'styled-components'
import { screenSizes } from '@shipt/design-system-themes'

export const CMSNoResultsFound = ({
  content_type_id,
  id,
}: Pick<PlaceholderData, 'content_type_id' | 'id'>) => {
  return (
    <div {...getCMSWrapperProps({ content_type_id, id })}>
      <NoResults
        text="No items to show yet"
        subText={"Once you place an order, you'll see the\nitems here for easy reordering."}
        hideButton
        imageInfo={{
          src: objectStorageUrl('error-search.png'),
          alt: 'No results found',
          width: 250,
          height: 250,
        }}
      />
    </div>
  )
}

const NoResults = styled(EmptyState)`
  h2 {
    font-size: 1.5rem;
  }

  @media ${screenSizes.max_mobile} {
    img {
      width: 160px;
      height: 160px;
    }
  }
`
